import { render } from "./StudentsView.vue?vue&type=template&id=ea540d4c&scoped=true"
import script from "./StudentsView.vue?vue&type=script&lang=js"
export * from "./StudentsView.vue?vue&type=script&lang=js"

import "./StudentsView.vue?vue&type=style&index=0&id=ea540d4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea540d4c"]])

export default __exports__